// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerWrap":"headerWrap___f4iwc","bodyWrap":"bodyWrap___CYrY7","searchTerm":"searchTerm___cEVDH","headerContent":"headerContent___s3A1F"};